/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const addCustomerTeamAssignmentBodyTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const addCustomerTeamAssignmentBodyExpectedCustomerVersionExclusiveMin = 0;
export const addCustomerTeamAssignmentBodyExpectedCustomerVersionMax = 9007199254740991;

export const AddCustomerTeamAssignmentBody = zod.object({
  teamId: zod.uuid().regex(addCustomerTeamAssignmentBodyTeamIdRegExp),
  expectedCustomerVersion: zod
    .int()
    .gt(addCustomerTeamAssignmentBodyExpectedCustomerVersionExclusiveMin)
    .max(addCustomerTeamAssignmentBodyExpectedCustomerVersionMax),
});

export type AddCustomerTeamAssignmentBody = zod.input<typeof AddCustomerTeamAssignmentBody>;
export type AddCustomerTeamAssignmentBodyOutput = zod.output<typeof AddCustomerTeamAssignmentBody>;
